<template>
  <div class="hit-container">

    <transition>
      <div v-bind:key="show" class="hit-panel hit-panel-info">
        <div v-if="show >= 1" class="hit-panel-heading" v-html='$t("message.validation")+" #"+$route.params.userID' />
          <div class="hit-panel-body" v-if="show >= 2">
            <div class="hit-alert hit-alert-success" v-if="!error">{{ $t("message.thankYou") }}</div>
            <div class="hit-alert hit-alert-warning" v-else>{{ error }}</div>

          </div>
          <div class="hit-panel-footer" v-if="show == 3" >
            <router-link class="hit-btn hit-btn-default hit-btn-block" :to="{ name: 'sign_in', params: {lang: $route.params.lang} }">{{ $t("message.signIn") }}</router-link>
          </div>
      </div>
    </transition>

  </div>
</template>

<script>

export default{
  data () {
    return {
      show: 1,
      error: false
    }
  },

  mounted () {
    this.$hit_post({url: 'user/confirmation',
      data: {user: this.$route.params.userID},
      callback: function (ret) {
        if (!ret.data[0]) { this.error = ret.data[1] }

        setTimeout(function () {
          this.show = 2

          setTimeout(function () {
            this.show = 3
          }.bind(this), 3000)
        }.bind(this), 2000)
      }.bind(this)})
  }
}

</script>
